import { createContext, useContext } from 'react';
import type { Theme } from '../types';

export const ThemeContext = createContext<Theme | null>(null);

export function useThemeContext(): Theme {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useThemeContext must be used within a ThemeContext.Provider');
  return ctx;
}

export interface ThemeSettings {
  dark: boolean;
  setDark: (v: boolean) => void;
  accent: string;
  setAccent: (v: string) => void;
}

export const ThemeSettingsContext = createContext<ThemeSettings | null>(null);

export function useThemeSettings(): ThemeSettings {
  const ctx = useContext(ThemeSettingsContext);
  if (!ctx) throw new Error('useThemeSettings must be used within a ThemeSettingsContext.Provider');
  return ctx;
}
